import script from "./BaseBtn.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseBtn.vue?vue&type=script&setup=true&lang=js"

import "./BaseBtn.vue?vue&type=style&index=0&id=7cbe1272&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7cbe1272"]])

export default __exports__